export default __webpack_public_path__ + "static/media/map-marked.b7194aaf.svg";